import React, { createContext, useContext, useMemo, useState } from 'react';

export type SelfAttendanceState = {
  missing: number | number[];
  pending: number;
};

type SelfAttendanceContextValue = {
  selfAttendance: SelfAttendanceState;
  setSelfAttendance: React.Dispatch<React.SetStateAction<SelfAttendanceState>>;
};

const initialState: SelfAttendanceState = {
  missing: 0,
  pending: 0,
};

const SelfAttendanceContext = createContext<SelfAttendanceContextValue | undefined>(undefined);

export const SelfAttendanceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selfAttendance, setSelfAttendance] = useState<SelfAttendanceState>(initialState);

  const value = useMemo(
    () => ({
      selfAttendance,
      setSelfAttendance,
    }),
    [selfAttendance]
  );

  return <SelfAttendanceContext.Provider value={value}>{children}</SelfAttendanceContext.Provider>;
};

export const useSelfAttendance = (): SelfAttendanceContextValue => {
  const context = useContext(SelfAttendanceContext);

  if (!context) {
    throw new Error('useSelfAttendance must be used within a SelfAttendanceProvider');
  }

  return context;
};
